import React from "react"
import Popup from "reactjs-popup"
import styled from 'styled-components'
import MobileMenuList from './MenuList/MobileMenuList'

const BurgerMenu = styled.div`
  display: inline-block;
  cursor: pointer;
  position: fixed;
  width: 50px;
  height: 50px;
  right: 0;
  top: 0;
  z-index: 9999;
  background: #fff;
  padding: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);

  .bar1, .bar2, .bar3 {
    width: 30px;
    height: 3px;
    background-color: #333;
    margin: 6px 0;
    transition: 0.4s;
  }
`

const BurgerMenuOpen = styled.div`
  display: inline-block;
  cursor: pointer;
  position: fixed;
  width: 50px;
  height: 50px;
  right: 0;
  top: 0;
  z-index: 9999;
  background: #fff;
  padding: 10px;

  .bar1, .bar2, .bar3 {
    width: 30px;
    height: 3px;
    background-color: #333;
    margin: 6px 0;
    transition: 0.4s;
  }

  .bar1 {
  -webkit-transform: rotate(-45deg) translate(-6px, 6px);
  transform: rotate(-45deg) translate(-6px, 6px);
  }

  .bar2 {
    opacity: 0;
  }

  .bar3 {
    -webkit-transform: rotate(45deg) translate(-6px, -6px);
    transform: rotate(45deg) translate(-6px, -6px);
  }
`

const BurgerIcon = React.forwardRef(({ open, ...props }, ref) => (
  <div>
    {open
      ?
        <BurgerMenuOpen ref={ref} {...props}>
          <div className="bar1" key="b1" />
          <div className="bar2" key="b2" />
          <div className="bar3" key="b3" />
        </BurgerMenuOpen>
      :
        <BurgerMenu ref={ref} {...props}>
          <div className="bar1" key="b1" />
          <div className="bar2" key="b2" />
          <div className="bar3" key="b3" />
        </BurgerMenu>
    }
  </div>
))

const MobileMenu = () => (
  <div className='lg:hidden'>
    <Popup
      modal
      overlayStyle={{ background: "rgba(255,255,255,0.98)" }}
      contentStyle={{ background: "rgba(255,255,255,0)", width: '80%', border: "none", margin: '2em auto 0' }}
      closeOnDocumentClick={false}
      trigger={open => <BurgerIcon open={open} />}
    >
      {close => <MobileMenuList close={close} />}
    </Popup>
  </div>
)

export default MobileMenu